module.exports = __webpack_public_path__ + "static/media/main2.1f1085c9.png";